import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './ImportantPlaceForm.module.css';
import LocationIconSelector from 'components/UI/LocationIconSelector/LocationIconSelector';
import { importantPlaceIcons } from 'shared/utility';
import * as actions from 'store/actions';

class ImportantPlaceForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showIconSelector: false,
      location: '',
      location2: '',
      LocIcon: null,
    };
  }

  componentDidMount() {
    const location = this.props.formType === 'edit' ? this.props.location.Location : this.props.location.location;
    const location2 = this.props.formType === 'edit' ? this.props.location.Location2 : this.props.location.location2;
    const locIcon = this.props.location.LocIcon ? this.props.location.LocIcon : null;
    this.setState({ location, location2, LocIcon: locIcon });
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.submitted && this.props.submitted) {
      this.props.handleLocationUpdate(this.state.location, this.state.location2, null, null, null, null, null, null, this.state.LocIcon, true);
      this.props.close();
    }
  }

  inputChangedHandler = (event, fieldName) => {
    const updatedInput = event.target.value;
    this.setState({ [fieldName]: updatedInput });
  };

  handleIconSelection = (iconName) => {
    this.setState({ LocIcon: iconName, showIconSelector: false });
  };

  handleSubmit = () => {
    if (this.state.location && this.state.location2) {
      if (this.props.formType === 'create') {
        this.props.onAddImportantPlace(
          this.state.location,
          this.state.location2,
          this.state.LocIcon,
          this.props.location.geoLocation.lat,
          this.props.location.geoLocation.lng,
          this.props.location.center.lat,
          this.props.location.center.lng,
          this.props.location.mapTypeId,
          this.props.location.zoom,
          this.props.location.heading,
          this.props.location.pitch,
        );
      } else if (this.props.formType === 'edit') {
        this.props.onUpdateImportantPlace(this.props.location.Id, this.state.location, this.state.location2, this.state.LocIcon);
      }
    }
  };

  handleDelete = () => {
    this.props.onUpdateImportantPlace(this.props.location.Id, null, null, null, true);
    this.props.handleLocationUpdate(null, null, null, null, null, null, null, null, null, false);
  };

  render = () => {
    let locationIcon = null;
    const errorMessage = this.props.error ? <p className={classes.ErrorMessage}>{this.props.error.replace(/_/g, ' ')}</p> : null;

    if (this.state.LocIcon) {
      locationIcon = importantPlaceIcons.find((icon) => icon.name === this.state.LocIcon);
    }

    const submitButtonClasses = [classes.Submit];
    if (!this.state.location || !this.state.location2) submitButtonClasses.push(classes.Disabled);

    let importantPlaceContents = (
      <div className={classes.FormContainer}>
        <div className={classes.FormContents}>
          <div className={classes.Title}>
            <h3>{this.props.formType === 'edit' ? 'Edit My Important Place' : 'Add to My Important Places'}</h3>
          </div>
          <div className={classes.FormFields}>
            <div className={classes.SelectLocIcon} onClick={() => this.setState({ showIconSelector: true })}>
              {locationIcon === null ? (
                <div className={classes.IconContainer}>
                  <p>Add Image</p>
                </div>
              ) : (
                <locationIcon.image type="ImportantPlaceForm" fillColor="#01a2db" alt="category image" />
              )}

              <span className={classes.IconSelectorChevron}>
                <FontAwesomeIcon icon="chevron-down" />
              </span>
            </div>
            {errorMessage}
            <form>
              <input
                className={classes.InputField}
                value={this.state.location}
                onChange={(e) => this.inputChangedHandler(e, 'location')}
                placeholder="(Required) Important Place Title"
              />
              <input
                className={classes.InputField}
                value={this.state.location2}
                onChange={(e) => this.inputChangedHandler(e, 'location2')}
                placeholder="(Required) Important Place Address"
              />
              <div className={classes.Buttons}>
                {this.props.formType === 'edit' ? <FontAwesomeIcon icon="trash" className={classes.DeleteIcon} onClick={this.handleDelete} /> : null}
                <div onClick={this.props.close} className={classes.Cancel}>
                  <p>Cancel</p>
                </div>
                <div onClick={this.handleSubmit} className={submitButtonClasses.join(' ')}>
                  <p>Save</p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );

    if (this.state.showIconSelector) {
      importantPlaceContents = <LocationIconSelector clicked={this.handleIconSelection} close={() => this.setState({ showIconSelector: false })} />;
    }
    return <div className={classes.OuterContainer}>{importantPlaceContents}</div>;
  };
}

const mapStateToProps = (state) => {
  return {
    loading: state.fav.loading,
    submitted: state.fav.submitted,
    error: state.fav.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAddImportantPlace: (Location, Location2, LocIcon, Lat, Lng, MapLat, MapLng, MapType, Zoom, Heading, Pitch) =>
      dispatch(actions.addImportantPlace(Location, Location2, LocIcon, Lat, Lng, MapLat, MapLng, MapType, Zoom, Heading, Pitch)),
    onUpdateImportantPlace: (Id, Location, Location2, LocIcon, Delete) =>
      dispatch(actions.updateImportantPlace(Id, Location, Location2, LocIcon, Delete)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ImportantPlaceForm);
